/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SuppliersIndexRouteImport } from './routes/suppliers/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as ReportsIndexRouteImport } from './routes/reports/index'
import { Route as ProductsIndexRouteImport } from './routes/products/index'
import { Route as NotificationsIndexRouteImport } from './routes/notifications/index'
import { Route as InvoicesIndexRouteImport } from './routes/invoices/index'
import { Route as DraftInvoiceIndexRouteImport } from './routes/draft-invoice/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as ClientsIndexRouteImport } from './routes/clients/index'
import { Route as AppsIndexRouteImport } from './routes/apps/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as SettingsSubscriptionIndexRouteImport } from './routes/settings/subscription/index'
import { Route as InvoicesInvoiceIdIndexRouteImport } from './routes/invoices/$invoiceId/index'
import { Route as AppsTreasuryIndexRouteImport } from './routes/apps/treasury/index'
import { Route as AppsSuppliersIndexRouteImport } from './routes/apps/suppliers/index'
import { Route as AppsServicesIndexRouteImport } from './routes/apps/services/index'
import { Route as AppsSalesIndexRouteImport } from './routes/apps/sales/index'
import { Route as AppsReportsIndexRouteImport } from './routes/apps/reports/index'
import { Route as AppsQuotesIndexRouteImport } from './routes/apps/quotes/index'
import { Route as AppsProductsIndexRouteImport } from './routes/apps/products/index'
import { Route as AppsPosIndexRouteImport } from './routes/apps/pos/index'
import { Route as AppsComplianceIndexRouteImport } from './routes/apps/compliance/index'
import { Route as AppsClientsIndexRouteImport } from './routes/apps/clients/index'
import { Route as AppsAccountingIndexRouteImport } from './routes/apps/accounting/index'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminPlansIndexRouteImport } from './routes/admin/plans/index'
import { Route as AdminLicensesIndexRouteImport } from './routes/admin/licenses/index'
import { Route as AdminGeographyIndexRouteImport } from './routes/admin/geography/index'
import { Route as AdminFeaturesIndexRouteImport } from './routes/admin/features/index'
import { Route as AdminCompaniesIndexRouteImport } from './routes/admin/companies/index'
import { Route as AdminAbTestsIndexRouteImport } from './routes/admin/ab-tests/index'
import { Route as AppsReportsTaxRouteImport } from './routes/apps/reports/tax'
import { Route as AppsReportsSalesRouteImport } from './routes/apps/reports/sales'
import { Route as AppsReportsExpensesRouteImport } from './routes/apps/reports/expenses'
import { Route as AppsReportsCashflowRouteImport } from './routes/apps/reports/cashflow'
import { Route as AppsComplianceSetupRouteImport } from './routes/apps/compliance/setup'
import { Route as AppsComplianceEtat104RouteImport } from './routes/apps/compliance/etat-104'
import { Route as AppsTreasuryTransfersIndexRouteImport } from './routes/apps/treasury/transfers/index'
import { Route as AppsTreasuryTransactionsIndexRouteImport } from './routes/apps/treasury/transactions/index'
import { Route as AppsTreasuryChecksIndexRouteImport } from './routes/apps/treasury/checks/index'
import { Route as AppsTreasuryAccountsIndexRouteImport } from './routes/apps/treasury/accounts/index'
import { Route as AppsPosKitchenIndexRouteImport } from './routes/apps/pos/kitchen/index'
import { Route as AppsPosHistoryIndexRouteImport } from './routes/apps/pos/history/index'
import { Route as AppsPosDisplayIndexRouteImport } from './routes/apps/pos/display/index'
import { Route as AppsAccountingEntriesIndexRouteImport } from './routes/apps/accounting/entries/index'
import { Route as AppsAccountingChartIndexRouteImport } from './routes/apps/accounting/chart/index'
import { Route as AdminLicensesLicenseIdIndexRouteImport } from './routes/admin/licenses/$licenseId/index'
import { Route as AppsAccountingReportsTrialBalanceRouteImport } from './routes/apps/accounting/reports/trial-balance'
import { Route as AppsAccountingReportsGeneralLedgerRouteImport } from './routes/apps/accounting/reports/general-ledger'
import { Route as AppsAccountingEntriesNewRouteImport } from './routes/apps/accounting/entries/new'
import { Route as AppsAccountingEntriesEntryIdRouteImport } from './routes/apps/accounting/entries/$entryId'
import { Route as AppsPosAdminTablesIndexRouteImport } from './routes/apps/pos/admin/tables/index'
import { Route as AppsPosAdminSettingsIndexRouteImport } from './routes/apps/pos/admin/settings/index'
import { Route as AppsPosAdminKitchenSettingsIndexRouteImport } from './routes/apps/pos/admin/kitchen-settings/index'
import { Route as AppsPosAdminAreasIndexRouteImport } from './routes/apps/pos/admin/areas/index'

const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SuppliersIndexRoute = SuppliersIndexRouteImport.update({
  id: '/suppliers/',
  path: '/suppliers/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsIndexRoute = ProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsIndexRoute = NotificationsIndexRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesIndexRoute = InvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => rootRouteImport,
} as any)
const DraftInvoiceIndexRoute = DraftInvoiceIndexRouteImport.update({
  id: '/draft-invoice/',
  path: '/draft-invoice/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsIndexRoute = ClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsIndexRoute = AppsIndexRouteImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/admin/dashboard',
  path: '/admin/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsSubscriptionIndexRoute =
  SettingsSubscriptionIndexRouteImport.update({
    id: '/settings/subscription/',
    path: '/settings/subscription/',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvoicesInvoiceIdIndexRoute = InvoicesInvoiceIdIndexRouteImport.update({
  id: '/invoices/$invoiceId/',
  path: '/invoices/$invoiceId/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsTreasuryIndexRoute = AppsTreasuryIndexRouteImport.update({
  id: '/apps/treasury/',
  path: '/apps/treasury/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsSuppliersIndexRoute = AppsSuppliersIndexRouteImport.update({
  id: '/apps/suppliers/',
  path: '/apps/suppliers/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsServicesIndexRoute = AppsServicesIndexRouteImport.update({
  id: '/apps/services/',
  path: '/apps/services/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsSalesIndexRoute = AppsSalesIndexRouteImport.update({
  id: '/apps/sales/',
  path: '/apps/sales/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsReportsIndexRoute = AppsReportsIndexRouteImport.update({
  id: '/apps/reports/',
  path: '/apps/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsQuotesIndexRoute = AppsQuotesIndexRouteImport.update({
  id: '/apps/quotes/',
  path: '/apps/quotes/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsProductsIndexRoute = AppsProductsIndexRouteImport.update({
  id: '/apps/products/',
  path: '/apps/products/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsPosIndexRoute = AppsPosIndexRouteImport.update({
  id: '/apps/pos/',
  path: '/apps/pos/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsComplianceIndexRoute = AppsComplianceIndexRouteImport.update({
  id: '/apps/compliance/',
  path: '/apps/compliance/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsClientsIndexRoute = AppsClientsIndexRouteImport.update({
  id: '/apps/clients/',
  path: '/apps/clients/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsAccountingIndexRoute = AppsAccountingIndexRouteImport.update({
  id: '/apps/accounting/',
  path: '/apps/accounting/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/admin/users/',
  path: '/admin/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPlansIndexRoute = AdminPlansIndexRouteImport.update({
  id: '/admin/plans/',
  path: '/admin/plans/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLicensesIndexRoute = AdminLicensesIndexRouteImport.update({
  id: '/admin/licenses/',
  path: '/admin/licenses/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminGeographyIndexRoute = AdminGeographyIndexRouteImport.update({
  id: '/admin/geography/',
  path: '/admin/geography/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminFeaturesIndexRoute = AdminFeaturesIndexRouteImport.update({
  id: '/admin/features/',
  path: '/admin/features/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCompaniesIndexRoute = AdminCompaniesIndexRouteImport.update({
  id: '/admin/companies/',
  path: '/admin/companies/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAbTestsIndexRoute = AdminAbTestsIndexRouteImport.update({
  id: '/admin/ab-tests/',
  path: '/admin/ab-tests/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsReportsTaxRoute = AppsReportsTaxRouteImport.update({
  id: '/apps/reports/tax',
  path: '/apps/reports/tax',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsReportsSalesRoute = AppsReportsSalesRouteImport.update({
  id: '/apps/reports/sales',
  path: '/apps/reports/sales',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsReportsExpensesRoute = AppsReportsExpensesRouteImport.update({
  id: '/apps/reports/expenses',
  path: '/apps/reports/expenses',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsReportsCashflowRoute = AppsReportsCashflowRouteImport.update({
  id: '/apps/reports/cashflow',
  path: '/apps/reports/cashflow',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsComplianceSetupRoute = AppsComplianceSetupRouteImport.update({
  id: '/apps/compliance/setup',
  path: '/apps/compliance/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsComplianceEtat104Route = AppsComplianceEtat104RouteImport.update({
  id: '/apps/compliance/etat-104',
  path: '/apps/compliance/etat-104',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsTreasuryTransfersIndexRoute =
  AppsTreasuryTransfersIndexRouteImport.update({
    id: '/apps/treasury/transfers/',
    path: '/apps/treasury/transfers/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppsTreasuryTransactionsIndexRoute =
  AppsTreasuryTransactionsIndexRouteImport.update({
    id: '/apps/treasury/transactions/',
    path: '/apps/treasury/transactions/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppsTreasuryChecksIndexRoute = AppsTreasuryChecksIndexRouteImport.update({
  id: '/apps/treasury/checks/',
  path: '/apps/treasury/checks/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsTreasuryAccountsIndexRoute =
  AppsTreasuryAccountsIndexRouteImport.update({
    id: '/apps/treasury/accounts/',
    path: '/apps/treasury/accounts/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppsPosKitchenIndexRoute = AppsPosKitchenIndexRouteImport.update({
  id: '/apps/pos/kitchen/',
  path: '/apps/pos/kitchen/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsPosHistoryIndexRoute = AppsPosHistoryIndexRouteImport.update({
  id: '/apps/pos/history/',
  path: '/apps/pos/history/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsPosDisplayIndexRoute = AppsPosDisplayIndexRouteImport.update({
  id: '/apps/pos/display/',
  path: '/apps/pos/display/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsAccountingEntriesIndexRoute =
  AppsAccountingEntriesIndexRouteImport.update({
    id: '/apps/accounting/entries/',
    path: '/apps/accounting/entries/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppsAccountingChartIndexRoute =
  AppsAccountingChartIndexRouteImport.update({
    id: '/apps/accounting/chart/',
    path: '/apps/accounting/chart/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminLicensesLicenseIdIndexRoute =
  AdminLicensesLicenseIdIndexRouteImport.update({
    id: '/admin/licenses/$licenseId/',
    path: '/admin/licenses/$licenseId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppsAccountingReportsTrialBalanceRoute =
  AppsAccountingReportsTrialBalanceRouteImport.update({
    id: '/apps/accounting/reports/trial-balance',
    path: '/apps/accounting/reports/trial-balance',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppsAccountingReportsGeneralLedgerRoute =
  AppsAccountingReportsGeneralLedgerRouteImport.update({
    id: '/apps/accounting/reports/general-ledger',
    path: '/apps/accounting/reports/general-ledger',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppsAccountingEntriesNewRoute =
  AppsAccountingEntriesNewRouteImport.update({
    id: '/apps/accounting/entries/new',
    path: '/apps/accounting/entries/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppsAccountingEntriesEntryIdRoute =
  AppsAccountingEntriesEntryIdRouteImport.update({
    id: '/apps/accounting/entries/$entryId',
    path: '/apps/accounting/entries/$entryId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppsPosAdminTablesIndexRoute = AppsPosAdminTablesIndexRouteImport.update({
  id: '/apps/pos/admin/tables/',
  path: '/apps/pos/admin/tables/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsPosAdminSettingsIndexRoute =
  AppsPosAdminSettingsIndexRouteImport.update({
    id: '/apps/pos/admin/settings/',
    path: '/apps/pos/admin/settings/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppsPosAdminKitchenSettingsIndexRoute =
  AppsPosAdminKitchenSettingsIndexRouteImport.update({
    id: '/apps/pos/admin/kitchen-settings/',
    path: '/apps/pos/admin/kitchen-settings/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppsPosAdminAreasIndexRoute = AppsPosAdminAreasIndexRouteImport.update({
  id: '/apps/pos/admin/areas/',
  path: '/apps/pos/admin/areas/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/': typeof AdminIndexRoute
  '/apps/': typeof AppsIndexRoute
  '/clients/': typeof ClientsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/draft-invoice/': typeof DraftInvoiceIndexRoute
  '/invoices/': typeof InvoicesIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/suppliers/': typeof SuppliersIndexRoute
  '/apps/compliance/etat-104': typeof AppsComplianceEtat104Route
  '/apps/compliance/setup': typeof AppsComplianceSetupRoute
  '/apps/reports/cashflow': typeof AppsReportsCashflowRoute
  '/apps/reports/expenses': typeof AppsReportsExpensesRoute
  '/apps/reports/sales': typeof AppsReportsSalesRoute
  '/apps/reports/tax': typeof AppsReportsTaxRoute
  '/admin/ab-tests/': typeof AdminAbTestsIndexRoute
  '/admin/companies/': typeof AdminCompaniesIndexRoute
  '/admin/features/': typeof AdminFeaturesIndexRoute
  '/admin/geography/': typeof AdminGeographyIndexRoute
  '/admin/licenses/': typeof AdminLicensesIndexRoute
  '/admin/plans/': typeof AdminPlansIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/apps/accounting/': typeof AppsAccountingIndexRoute
  '/apps/clients/': typeof AppsClientsIndexRoute
  '/apps/compliance/': typeof AppsComplianceIndexRoute
  '/apps/pos/': typeof AppsPosIndexRoute
  '/apps/products/': typeof AppsProductsIndexRoute
  '/apps/quotes/': typeof AppsQuotesIndexRoute
  '/apps/reports/': typeof AppsReportsIndexRoute
  '/apps/sales/': typeof AppsSalesIndexRoute
  '/apps/services/': typeof AppsServicesIndexRoute
  '/apps/suppliers/': typeof AppsSuppliersIndexRoute
  '/apps/treasury/': typeof AppsTreasuryIndexRoute
  '/invoices/$invoiceId/': typeof InvoicesInvoiceIdIndexRoute
  '/settings/subscription/': typeof SettingsSubscriptionIndexRoute
  '/apps/accounting/entries/$entryId': typeof AppsAccountingEntriesEntryIdRoute
  '/apps/accounting/entries/new': typeof AppsAccountingEntriesNewRoute
  '/apps/accounting/reports/general-ledger': typeof AppsAccountingReportsGeneralLedgerRoute
  '/apps/accounting/reports/trial-balance': typeof AppsAccountingReportsTrialBalanceRoute
  '/admin/licenses/$licenseId/': typeof AdminLicensesLicenseIdIndexRoute
  '/apps/accounting/chart/': typeof AppsAccountingChartIndexRoute
  '/apps/accounting/entries/': typeof AppsAccountingEntriesIndexRoute
  '/apps/pos/display/': typeof AppsPosDisplayIndexRoute
  '/apps/pos/history/': typeof AppsPosHistoryIndexRoute
  '/apps/pos/kitchen/': typeof AppsPosKitchenIndexRoute
  '/apps/treasury/accounts/': typeof AppsTreasuryAccountsIndexRoute
  '/apps/treasury/checks/': typeof AppsTreasuryChecksIndexRoute
  '/apps/treasury/transactions/': typeof AppsTreasuryTransactionsIndexRoute
  '/apps/treasury/transfers/': typeof AppsTreasuryTransfersIndexRoute
  '/apps/pos/admin/areas/': typeof AppsPosAdminAreasIndexRoute
  '/apps/pos/admin/kitchen-settings/': typeof AppsPosAdminKitchenSettingsIndexRoute
  '/apps/pos/admin/settings/': typeof AppsPosAdminSettingsIndexRoute
  '/apps/pos/admin/tables/': typeof AppsPosAdminTablesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin': typeof AdminIndexRoute
  '/apps': typeof AppsIndexRoute
  '/clients': typeof ClientsIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/draft-invoice': typeof DraftInvoiceIndexRoute
  '/invoices': typeof InvoicesIndexRoute
  '/notifications': typeof NotificationsIndexRoute
  '/products': typeof ProductsIndexRoute
  '/reports': typeof ReportsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/suppliers': typeof SuppliersIndexRoute
  '/apps/compliance/etat-104': typeof AppsComplianceEtat104Route
  '/apps/compliance/setup': typeof AppsComplianceSetupRoute
  '/apps/reports/cashflow': typeof AppsReportsCashflowRoute
  '/apps/reports/expenses': typeof AppsReportsExpensesRoute
  '/apps/reports/sales': typeof AppsReportsSalesRoute
  '/apps/reports/tax': typeof AppsReportsTaxRoute
  '/admin/ab-tests': typeof AdminAbTestsIndexRoute
  '/admin/companies': typeof AdminCompaniesIndexRoute
  '/admin/features': typeof AdminFeaturesIndexRoute
  '/admin/geography': typeof AdminGeographyIndexRoute
  '/admin/licenses': typeof AdminLicensesIndexRoute
  '/admin/plans': typeof AdminPlansIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/apps/accounting': typeof AppsAccountingIndexRoute
  '/apps/clients': typeof AppsClientsIndexRoute
  '/apps/compliance': typeof AppsComplianceIndexRoute
  '/apps/pos': typeof AppsPosIndexRoute
  '/apps/products': typeof AppsProductsIndexRoute
  '/apps/quotes': typeof AppsQuotesIndexRoute
  '/apps/reports': typeof AppsReportsIndexRoute
  '/apps/sales': typeof AppsSalesIndexRoute
  '/apps/services': typeof AppsServicesIndexRoute
  '/apps/suppliers': typeof AppsSuppliersIndexRoute
  '/apps/treasury': typeof AppsTreasuryIndexRoute
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdIndexRoute
  '/settings/subscription': typeof SettingsSubscriptionIndexRoute
  '/apps/accounting/entries/$entryId': typeof AppsAccountingEntriesEntryIdRoute
  '/apps/accounting/entries/new': typeof AppsAccountingEntriesNewRoute
  '/apps/accounting/reports/general-ledger': typeof AppsAccountingReportsGeneralLedgerRoute
  '/apps/accounting/reports/trial-balance': typeof AppsAccountingReportsTrialBalanceRoute
  '/admin/licenses/$licenseId': typeof AdminLicensesLicenseIdIndexRoute
  '/apps/accounting/chart': typeof AppsAccountingChartIndexRoute
  '/apps/accounting/entries': typeof AppsAccountingEntriesIndexRoute
  '/apps/pos/display': typeof AppsPosDisplayIndexRoute
  '/apps/pos/history': typeof AppsPosHistoryIndexRoute
  '/apps/pos/kitchen': typeof AppsPosKitchenIndexRoute
  '/apps/treasury/accounts': typeof AppsTreasuryAccountsIndexRoute
  '/apps/treasury/checks': typeof AppsTreasuryChecksIndexRoute
  '/apps/treasury/transactions': typeof AppsTreasuryTransactionsIndexRoute
  '/apps/treasury/transfers': typeof AppsTreasuryTransfersIndexRoute
  '/apps/pos/admin/areas': typeof AppsPosAdminAreasIndexRoute
  '/apps/pos/admin/kitchen-settings': typeof AppsPosAdminKitchenSettingsIndexRoute
  '/apps/pos/admin/settings': typeof AppsPosAdminSettingsIndexRoute
  '/apps/pos/admin/tables': typeof AppsPosAdminTablesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/': typeof AdminIndexRoute
  '/apps/': typeof AppsIndexRoute
  '/clients/': typeof ClientsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/draft-invoice/': typeof DraftInvoiceIndexRoute
  '/invoices/': typeof InvoicesIndexRoute
  '/notifications/': typeof NotificationsIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/suppliers/': typeof SuppliersIndexRoute
  '/apps/compliance/etat-104': typeof AppsComplianceEtat104Route
  '/apps/compliance/setup': typeof AppsComplianceSetupRoute
  '/apps/reports/cashflow': typeof AppsReportsCashflowRoute
  '/apps/reports/expenses': typeof AppsReportsExpensesRoute
  '/apps/reports/sales': typeof AppsReportsSalesRoute
  '/apps/reports/tax': typeof AppsReportsTaxRoute
  '/admin/ab-tests/': typeof AdminAbTestsIndexRoute
  '/admin/companies/': typeof AdminCompaniesIndexRoute
  '/admin/features/': typeof AdminFeaturesIndexRoute
  '/admin/geography/': typeof AdminGeographyIndexRoute
  '/admin/licenses/': typeof AdminLicensesIndexRoute
  '/admin/plans/': typeof AdminPlansIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/apps/accounting/': typeof AppsAccountingIndexRoute
  '/apps/clients/': typeof AppsClientsIndexRoute
  '/apps/compliance/': typeof AppsComplianceIndexRoute
  '/apps/pos/': typeof AppsPosIndexRoute
  '/apps/products/': typeof AppsProductsIndexRoute
  '/apps/quotes/': typeof AppsQuotesIndexRoute
  '/apps/reports/': typeof AppsReportsIndexRoute
  '/apps/sales/': typeof AppsSalesIndexRoute
  '/apps/services/': typeof AppsServicesIndexRoute
  '/apps/suppliers/': typeof AppsSuppliersIndexRoute
  '/apps/treasury/': typeof AppsTreasuryIndexRoute
  '/invoices/$invoiceId/': typeof InvoicesInvoiceIdIndexRoute
  '/settings/subscription/': typeof SettingsSubscriptionIndexRoute
  '/apps/accounting/entries/$entryId': typeof AppsAccountingEntriesEntryIdRoute
  '/apps/accounting/entries/new': typeof AppsAccountingEntriesNewRoute
  '/apps/accounting/reports/general-ledger': typeof AppsAccountingReportsGeneralLedgerRoute
  '/apps/accounting/reports/trial-balance': typeof AppsAccountingReportsTrialBalanceRoute
  '/admin/licenses/$licenseId/': typeof AdminLicensesLicenseIdIndexRoute
  '/apps/accounting/chart/': typeof AppsAccountingChartIndexRoute
  '/apps/accounting/entries/': typeof AppsAccountingEntriesIndexRoute
  '/apps/pos/display/': typeof AppsPosDisplayIndexRoute
  '/apps/pos/history/': typeof AppsPosHistoryIndexRoute
  '/apps/pos/kitchen/': typeof AppsPosKitchenIndexRoute
  '/apps/treasury/accounts/': typeof AppsTreasuryAccountsIndexRoute
  '/apps/treasury/checks/': typeof AppsTreasuryChecksIndexRoute
  '/apps/treasury/transactions/': typeof AppsTreasuryTransactionsIndexRoute
  '/apps/treasury/transfers/': typeof AppsTreasuryTransfersIndexRoute
  '/apps/pos/admin/areas/': typeof AppsPosAdminAreasIndexRoute
  '/apps/pos/admin/kitchen-settings/': typeof AppsPosAdminKitchenSettingsIndexRoute
  '/apps/pos/admin/settings/': typeof AppsPosAdminSettingsIndexRoute
  '/apps/pos/admin/tables/': typeof AppsPosAdminTablesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/register'
    | '/admin/dashboard'
    | '/admin/'
    | '/apps/'
    | '/clients/'
    | '/dashboard/'
    | '/draft-invoice/'
    | '/invoices/'
    | '/notifications/'
    | '/products/'
    | '/reports/'
    | '/settings/'
    | '/suppliers/'
    | '/apps/compliance/etat-104'
    | '/apps/compliance/setup'
    | '/apps/reports/cashflow'
    | '/apps/reports/expenses'
    | '/apps/reports/sales'
    | '/apps/reports/tax'
    | '/admin/ab-tests/'
    | '/admin/companies/'
    | '/admin/features/'
    | '/admin/geography/'
    | '/admin/licenses/'
    | '/admin/plans/'
    | '/admin/users/'
    | '/apps/accounting/'
    | '/apps/clients/'
    | '/apps/compliance/'
    | '/apps/pos/'
    | '/apps/products/'
    | '/apps/quotes/'
    | '/apps/reports/'
    | '/apps/sales/'
    | '/apps/services/'
    | '/apps/suppliers/'
    | '/apps/treasury/'
    | '/invoices/$invoiceId/'
    | '/settings/subscription/'
    | '/apps/accounting/entries/$entryId'
    | '/apps/accounting/entries/new'
    | '/apps/accounting/reports/general-ledger'
    | '/apps/accounting/reports/trial-balance'
    | '/admin/licenses/$licenseId/'
    | '/apps/accounting/chart/'
    | '/apps/accounting/entries/'
    | '/apps/pos/display/'
    | '/apps/pos/history/'
    | '/apps/pos/kitchen/'
    | '/apps/treasury/accounts/'
    | '/apps/treasury/checks/'
    | '/apps/treasury/transactions/'
    | '/apps/treasury/transfers/'
    | '/apps/pos/admin/areas/'
    | '/apps/pos/admin/kitchen-settings/'
    | '/apps/pos/admin/settings/'
    | '/apps/pos/admin/tables/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/register'
    | '/admin/dashboard'
    | '/admin'
    | '/apps'
    | '/clients'
    | '/dashboard'
    | '/draft-invoice'
    | '/invoices'
    | '/notifications'
    | '/products'
    | '/reports'
    | '/settings'
    | '/suppliers'
    | '/apps/compliance/etat-104'
    | '/apps/compliance/setup'
    | '/apps/reports/cashflow'
    | '/apps/reports/expenses'
    | '/apps/reports/sales'
    | '/apps/reports/tax'
    | '/admin/ab-tests'
    | '/admin/companies'
    | '/admin/features'
    | '/admin/geography'
    | '/admin/licenses'
    | '/admin/plans'
    | '/admin/users'
    | '/apps/accounting'
    | '/apps/clients'
    | '/apps/compliance'
    | '/apps/pos'
    | '/apps/products'
    | '/apps/quotes'
    | '/apps/reports'
    | '/apps/sales'
    | '/apps/services'
    | '/apps/suppliers'
    | '/apps/treasury'
    | '/invoices/$invoiceId'
    | '/settings/subscription'
    | '/apps/accounting/entries/$entryId'
    | '/apps/accounting/entries/new'
    | '/apps/accounting/reports/general-ledger'
    | '/apps/accounting/reports/trial-balance'
    | '/admin/licenses/$licenseId'
    | '/apps/accounting/chart'
    | '/apps/accounting/entries'
    | '/apps/pos/display'
    | '/apps/pos/history'
    | '/apps/pos/kitchen'
    | '/apps/treasury/accounts'
    | '/apps/treasury/checks'
    | '/apps/treasury/transactions'
    | '/apps/treasury/transfers'
    | '/apps/pos/admin/areas'
    | '/apps/pos/admin/kitchen-settings'
    | '/apps/pos/admin/settings'
    | '/apps/pos/admin/tables'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/register'
    | '/admin/dashboard'
    | '/admin/'
    | '/apps/'
    | '/clients/'
    | '/dashboard/'
    | '/draft-invoice/'
    | '/invoices/'
    | '/notifications/'
    | '/products/'
    | '/reports/'
    | '/settings/'
    | '/suppliers/'
    | '/apps/compliance/etat-104'
    | '/apps/compliance/setup'
    | '/apps/reports/cashflow'
    | '/apps/reports/expenses'
    | '/apps/reports/sales'
    | '/apps/reports/tax'
    | '/admin/ab-tests/'
    | '/admin/companies/'
    | '/admin/features/'
    | '/admin/geography/'
    | '/admin/licenses/'
    | '/admin/plans/'
    | '/admin/users/'
    | '/apps/accounting/'
    | '/apps/clients/'
    | '/apps/compliance/'
    | '/apps/pos/'
    | '/apps/products/'
    | '/apps/quotes/'
    | '/apps/reports/'
    | '/apps/sales/'
    | '/apps/services/'
    | '/apps/suppliers/'
    | '/apps/treasury/'
    | '/invoices/$invoiceId/'
    | '/settings/subscription/'
    | '/apps/accounting/entries/$entryId'
    | '/apps/accounting/entries/new'
    | '/apps/accounting/reports/general-ledger'
    | '/apps/accounting/reports/trial-balance'
    | '/admin/licenses/$licenseId/'
    | '/apps/accounting/chart/'
    | '/apps/accounting/entries/'
    | '/apps/pos/display/'
    | '/apps/pos/history/'
    | '/apps/pos/kitchen/'
    | '/apps/treasury/accounts/'
    | '/apps/treasury/checks/'
    | '/apps/treasury/transactions/'
    | '/apps/treasury/transfers/'
    | '/apps/pos/admin/areas/'
    | '/apps/pos/admin/kitchen-settings/'
    | '/apps/pos/admin/settings/'
    | '/apps/pos/admin/tables/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AppsIndexRoute: typeof AppsIndexRoute
  ClientsIndexRoute: typeof ClientsIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DraftInvoiceIndexRoute: typeof DraftInvoiceIndexRoute
  InvoicesIndexRoute: typeof InvoicesIndexRoute
  NotificationsIndexRoute: typeof NotificationsIndexRoute
  ProductsIndexRoute: typeof ProductsIndexRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  SuppliersIndexRoute: typeof SuppliersIndexRoute
  AppsComplianceEtat104Route: typeof AppsComplianceEtat104Route
  AppsComplianceSetupRoute: typeof AppsComplianceSetupRoute
  AppsReportsCashflowRoute: typeof AppsReportsCashflowRoute
  AppsReportsExpensesRoute: typeof AppsReportsExpensesRoute
  AppsReportsSalesRoute: typeof AppsReportsSalesRoute
  AppsReportsTaxRoute: typeof AppsReportsTaxRoute
  AdminAbTestsIndexRoute: typeof AdminAbTestsIndexRoute
  AdminCompaniesIndexRoute: typeof AdminCompaniesIndexRoute
  AdminFeaturesIndexRoute: typeof AdminFeaturesIndexRoute
  AdminGeographyIndexRoute: typeof AdminGeographyIndexRoute
  AdminLicensesIndexRoute: typeof AdminLicensesIndexRoute
  AdminPlansIndexRoute: typeof AdminPlansIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
  AppsAccountingIndexRoute: typeof AppsAccountingIndexRoute
  AppsClientsIndexRoute: typeof AppsClientsIndexRoute
  AppsComplianceIndexRoute: typeof AppsComplianceIndexRoute
  AppsPosIndexRoute: typeof AppsPosIndexRoute
  AppsProductsIndexRoute: typeof AppsProductsIndexRoute
  AppsQuotesIndexRoute: typeof AppsQuotesIndexRoute
  AppsReportsIndexRoute: typeof AppsReportsIndexRoute
  AppsSalesIndexRoute: typeof AppsSalesIndexRoute
  AppsServicesIndexRoute: typeof AppsServicesIndexRoute
  AppsSuppliersIndexRoute: typeof AppsSuppliersIndexRoute
  AppsTreasuryIndexRoute: typeof AppsTreasuryIndexRoute
  InvoicesInvoiceIdIndexRoute: typeof InvoicesInvoiceIdIndexRoute
  SettingsSubscriptionIndexRoute: typeof SettingsSubscriptionIndexRoute
  AppsAccountingEntriesEntryIdRoute: typeof AppsAccountingEntriesEntryIdRoute
  AppsAccountingEntriesNewRoute: typeof AppsAccountingEntriesNewRoute
  AppsAccountingReportsGeneralLedgerRoute: typeof AppsAccountingReportsGeneralLedgerRoute
  AppsAccountingReportsTrialBalanceRoute: typeof AppsAccountingReportsTrialBalanceRoute
  AdminLicensesLicenseIdIndexRoute: typeof AdminLicensesLicenseIdIndexRoute
  AppsAccountingChartIndexRoute: typeof AppsAccountingChartIndexRoute
  AppsAccountingEntriesIndexRoute: typeof AppsAccountingEntriesIndexRoute
  AppsPosDisplayIndexRoute: typeof AppsPosDisplayIndexRoute
  AppsPosHistoryIndexRoute: typeof AppsPosHistoryIndexRoute
  AppsPosKitchenIndexRoute: typeof AppsPosKitchenIndexRoute
  AppsTreasuryAccountsIndexRoute: typeof AppsTreasuryAccountsIndexRoute
  AppsTreasuryChecksIndexRoute: typeof AppsTreasuryChecksIndexRoute
  AppsTreasuryTransactionsIndexRoute: typeof AppsTreasuryTransactionsIndexRoute
  AppsTreasuryTransfersIndexRoute: typeof AppsTreasuryTransfersIndexRoute
  AppsPosAdminAreasIndexRoute: typeof AppsPosAdminAreasIndexRoute
  AppsPosAdminKitchenSettingsIndexRoute: typeof AppsPosAdminKitchenSettingsIndexRoute
  AppsPosAdminSettingsIndexRoute: typeof AppsPosAdminSettingsIndexRoute
  AppsPosAdminTablesIndexRoute: typeof AppsPosAdminTablesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suppliers/': {
      id: '/suppliers/'
      path: '/suppliers'
      fullPath: '/suppliers/'
      preLoaderRoute: typeof SuppliersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/': {
      id: '/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/': {
      id: '/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof ProductsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications/': {
      id: '/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof NotificationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/': {
      id: '/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof InvoicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/draft-invoice/': {
      id: '/draft-invoice/'
      path: '/draft-invoice'
      fullPath: '/draft-invoice/'
      preLoaderRoute: typeof DraftInvoiceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/': {
      id: '/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof ClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/': {
      id: '/apps/'
      path: '/apps'
      fullPath: '/apps/'
      preLoaderRoute: typeof AppsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/admin/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/subscription/': {
      id: '/settings/subscription/'
      path: '/settings/subscription'
      fullPath: '/settings/subscription/'
      preLoaderRoute: typeof SettingsSubscriptionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/$invoiceId/': {
      id: '/invoices/$invoiceId/'
      path: '/invoices/$invoiceId'
      fullPath: '/invoices/$invoiceId/'
      preLoaderRoute: typeof InvoicesInvoiceIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/treasury/': {
      id: '/apps/treasury/'
      path: '/apps/treasury'
      fullPath: '/apps/treasury/'
      preLoaderRoute: typeof AppsTreasuryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/suppliers/': {
      id: '/apps/suppliers/'
      path: '/apps/suppliers'
      fullPath: '/apps/suppliers/'
      preLoaderRoute: typeof AppsSuppliersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/services/': {
      id: '/apps/services/'
      path: '/apps/services'
      fullPath: '/apps/services/'
      preLoaderRoute: typeof AppsServicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/sales/': {
      id: '/apps/sales/'
      path: '/apps/sales'
      fullPath: '/apps/sales/'
      preLoaderRoute: typeof AppsSalesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/reports/': {
      id: '/apps/reports/'
      path: '/apps/reports'
      fullPath: '/apps/reports/'
      preLoaderRoute: typeof AppsReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/quotes/': {
      id: '/apps/quotes/'
      path: '/apps/quotes'
      fullPath: '/apps/quotes/'
      preLoaderRoute: typeof AppsQuotesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/products/': {
      id: '/apps/products/'
      path: '/apps/products'
      fullPath: '/apps/products/'
      preLoaderRoute: typeof AppsProductsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/pos/': {
      id: '/apps/pos/'
      path: '/apps/pos'
      fullPath: '/apps/pos/'
      preLoaderRoute: typeof AppsPosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/compliance/': {
      id: '/apps/compliance/'
      path: '/apps/compliance'
      fullPath: '/apps/compliance/'
      preLoaderRoute: typeof AppsComplianceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/clients/': {
      id: '/apps/clients/'
      path: '/apps/clients'
      fullPath: '/apps/clients/'
      preLoaderRoute: typeof AppsClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/accounting/': {
      id: '/apps/accounting/'
      path: '/apps/accounting'
      fullPath: '/apps/accounting/'
      preLoaderRoute: typeof AppsAccountingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/plans/': {
      id: '/admin/plans/'
      path: '/admin/plans'
      fullPath: '/admin/plans/'
      preLoaderRoute: typeof AdminPlansIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/licenses/': {
      id: '/admin/licenses/'
      path: '/admin/licenses'
      fullPath: '/admin/licenses/'
      preLoaderRoute: typeof AdminLicensesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/geography/': {
      id: '/admin/geography/'
      path: '/admin/geography'
      fullPath: '/admin/geography/'
      preLoaderRoute: typeof AdminGeographyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/features/': {
      id: '/admin/features/'
      path: '/admin/features'
      fullPath: '/admin/features/'
      preLoaderRoute: typeof AdminFeaturesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/companies/': {
      id: '/admin/companies/'
      path: '/admin/companies'
      fullPath: '/admin/companies/'
      preLoaderRoute: typeof AdminCompaniesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/ab-tests/': {
      id: '/admin/ab-tests/'
      path: '/admin/ab-tests'
      fullPath: '/admin/ab-tests/'
      preLoaderRoute: typeof AdminAbTestsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/reports/tax': {
      id: '/apps/reports/tax'
      path: '/apps/reports/tax'
      fullPath: '/apps/reports/tax'
      preLoaderRoute: typeof AppsReportsTaxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/reports/sales': {
      id: '/apps/reports/sales'
      path: '/apps/reports/sales'
      fullPath: '/apps/reports/sales'
      preLoaderRoute: typeof AppsReportsSalesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/reports/expenses': {
      id: '/apps/reports/expenses'
      path: '/apps/reports/expenses'
      fullPath: '/apps/reports/expenses'
      preLoaderRoute: typeof AppsReportsExpensesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/reports/cashflow': {
      id: '/apps/reports/cashflow'
      path: '/apps/reports/cashflow'
      fullPath: '/apps/reports/cashflow'
      preLoaderRoute: typeof AppsReportsCashflowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/compliance/setup': {
      id: '/apps/compliance/setup'
      path: '/apps/compliance/setup'
      fullPath: '/apps/compliance/setup'
      preLoaderRoute: typeof AppsComplianceSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/compliance/etat-104': {
      id: '/apps/compliance/etat-104'
      path: '/apps/compliance/etat-104'
      fullPath: '/apps/compliance/etat-104'
      preLoaderRoute: typeof AppsComplianceEtat104RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/treasury/transfers/': {
      id: '/apps/treasury/transfers/'
      path: '/apps/treasury/transfers'
      fullPath: '/apps/treasury/transfers/'
      preLoaderRoute: typeof AppsTreasuryTransfersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/treasury/transactions/': {
      id: '/apps/treasury/transactions/'
      path: '/apps/treasury/transactions'
      fullPath: '/apps/treasury/transactions/'
      preLoaderRoute: typeof AppsTreasuryTransactionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/treasury/checks/': {
      id: '/apps/treasury/checks/'
      path: '/apps/treasury/checks'
      fullPath: '/apps/treasury/checks/'
      preLoaderRoute: typeof AppsTreasuryChecksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/treasury/accounts/': {
      id: '/apps/treasury/accounts/'
      path: '/apps/treasury/accounts'
      fullPath: '/apps/treasury/accounts/'
      preLoaderRoute: typeof AppsTreasuryAccountsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/pos/kitchen/': {
      id: '/apps/pos/kitchen/'
      path: '/apps/pos/kitchen'
      fullPath: '/apps/pos/kitchen/'
      preLoaderRoute: typeof AppsPosKitchenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/pos/history/': {
      id: '/apps/pos/history/'
      path: '/apps/pos/history'
      fullPath: '/apps/pos/history/'
      preLoaderRoute: typeof AppsPosHistoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/pos/display/': {
      id: '/apps/pos/display/'
      path: '/apps/pos/display'
      fullPath: '/apps/pos/display/'
      preLoaderRoute: typeof AppsPosDisplayIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/accounting/entries/': {
      id: '/apps/accounting/entries/'
      path: '/apps/accounting/entries'
      fullPath: '/apps/accounting/entries/'
      preLoaderRoute: typeof AppsAccountingEntriesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/accounting/chart/': {
      id: '/apps/accounting/chart/'
      path: '/apps/accounting/chart'
      fullPath: '/apps/accounting/chart/'
      preLoaderRoute: typeof AppsAccountingChartIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/licenses/$licenseId/': {
      id: '/admin/licenses/$licenseId/'
      path: '/admin/licenses/$licenseId'
      fullPath: '/admin/licenses/$licenseId/'
      preLoaderRoute: typeof AdminLicensesLicenseIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/accounting/reports/trial-balance': {
      id: '/apps/accounting/reports/trial-balance'
      path: '/apps/accounting/reports/trial-balance'
      fullPath: '/apps/accounting/reports/trial-balance'
      preLoaderRoute: typeof AppsAccountingReportsTrialBalanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/accounting/reports/general-ledger': {
      id: '/apps/accounting/reports/general-ledger'
      path: '/apps/accounting/reports/general-ledger'
      fullPath: '/apps/accounting/reports/general-ledger'
      preLoaderRoute: typeof AppsAccountingReportsGeneralLedgerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/accounting/entries/new': {
      id: '/apps/accounting/entries/new'
      path: '/apps/accounting/entries/new'
      fullPath: '/apps/accounting/entries/new'
      preLoaderRoute: typeof AppsAccountingEntriesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/accounting/entries/$entryId': {
      id: '/apps/accounting/entries/$entryId'
      path: '/apps/accounting/entries/$entryId'
      fullPath: '/apps/accounting/entries/$entryId'
      preLoaderRoute: typeof AppsAccountingEntriesEntryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/pos/admin/tables/': {
      id: '/apps/pos/admin/tables/'
      path: '/apps/pos/admin/tables'
      fullPath: '/apps/pos/admin/tables/'
      preLoaderRoute: typeof AppsPosAdminTablesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/pos/admin/settings/': {
      id: '/apps/pos/admin/settings/'
      path: '/apps/pos/admin/settings'
      fullPath: '/apps/pos/admin/settings/'
      preLoaderRoute: typeof AppsPosAdminSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/pos/admin/kitchen-settings/': {
      id: '/apps/pos/admin/kitchen-settings/'
      path: '/apps/pos/admin/kitchen-settings'
      fullPath: '/apps/pos/admin/kitchen-settings/'
      preLoaderRoute: typeof AppsPosAdminKitchenSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/pos/admin/areas/': {
      id: '/apps/pos/admin/areas/'
      path: '/apps/pos/admin/areas'
      fullPath: '/apps/pos/admin/areas/'
      preLoaderRoute: typeof AppsPosAdminAreasIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  AdminDashboardRoute: AdminDashboardRoute,
  AdminIndexRoute: AdminIndexRoute,
  AppsIndexRoute: AppsIndexRoute,
  ClientsIndexRoute: ClientsIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DraftInvoiceIndexRoute: DraftInvoiceIndexRoute,
  InvoicesIndexRoute: InvoicesIndexRoute,
  NotificationsIndexRoute: NotificationsIndexRoute,
  ProductsIndexRoute: ProductsIndexRoute,
  ReportsIndexRoute: ReportsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  SuppliersIndexRoute: SuppliersIndexRoute,
  AppsComplianceEtat104Route: AppsComplianceEtat104Route,
  AppsComplianceSetupRoute: AppsComplianceSetupRoute,
  AppsReportsCashflowRoute: AppsReportsCashflowRoute,
  AppsReportsExpensesRoute: AppsReportsExpensesRoute,
  AppsReportsSalesRoute: AppsReportsSalesRoute,
  AppsReportsTaxRoute: AppsReportsTaxRoute,
  AdminAbTestsIndexRoute: AdminAbTestsIndexRoute,
  AdminCompaniesIndexRoute: AdminCompaniesIndexRoute,
  AdminFeaturesIndexRoute: AdminFeaturesIndexRoute,
  AdminGeographyIndexRoute: AdminGeographyIndexRoute,
  AdminLicensesIndexRoute: AdminLicensesIndexRoute,
  AdminPlansIndexRoute: AdminPlansIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
  AppsAccountingIndexRoute: AppsAccountingIndexRoute,
  AppsClientsIndexRoute: AppsClientsIndexRoute,
  AppsComplianceIndexRoute: AppsComplianceIndexRoute,
  AppsPosIndexRoute: AppsPosIndexRoute,
  AppsProductsIndexRoute: AppsProductsIndexRoute,
  AppsQuotesIndexRoute: AppsQuotesIndexRoute,
  AppsReportsIndexRoute: AppsReportsIndexRoute,
  AppsSalesIndexRoute: AppsSalesIndexRoute,
  AppsServicesIndexRoute: AppsServicesIndexRoute,
  AppsSuppliersIndexRoute: AppsSuppliersIndexRoute,
  AppsTreasuryIndexRoute: AppsTreasuryIndexRoute,
  InvoicesInvoiceIdIndexRoute: InvoicesInvoiceIdIndexRoute,
  SettingsSubscriptionIndexRoute: SettingsSubscriptionIndexRoute,
  AppsAccountingEntriesEntryIdRoute: AppsAccountingEntriesEntryIdRoute,
  AppsAccountingEntriesNewRoute: AppsAccountingEntriesNewRoute,
  AppsAccountingReportsGeneralLedgerRoute:
    AppsAccountingReportsGeneralLedgerRoute,
  AppsAccountingReportsTrialBalanceRoute:
    AppsAccountingReportsTrialBalanceRoute,
  AdminLicensesLicenseIdIndexRoute: AdminLicensesLicenseIdIndexRoute,
  AppsAccountingChartIndexRoute: AppsAccountingChartIndexRoute,
  AppsAccountingEntriesIndexRoute: AppsAccountingEntriesIndexRoute,
  AppsPosDisplayIndexRoute: AppsPosDisplayIndexRoute,
  AppsPosHistoryIndexRoute: AppsPosHistoryIndexRoute,
  AppsPosKitchenIndexRoute: AppsPosKitchenIndexRoute,
  AppsTreasuryAccountsIndexRoute: AppsTreasuryAccountsIndexRoute,
  AppsTreasuryChecksIndexRoute: AppsTreasuryChecksIndexRoute,
  AppsTreasuryTransactionsIndexRoute: AppsTreasuryTransactionsIndexRoute,
  AppsTreasuryTransfersIndexRoute: AppsTreasuryTransfersIndexRoute,
  AppsPosAdminAreasIndexRoute: AppsPosAdminAreasIndexRoute,
  AppsPosAdminKitchenSettingsIndexRoute: AppsPosAdminKitchenSettingsIndexRoute,
  AppsPosAdminSettingsIndexRoute: AppsPosAdminSettingsIndexRoute,
  AppsPosAdminTablesIndexRoute: AppsPosAdminTablesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
